@if (dropOffId()) {
  <div [class.button-compact-mode]="isCompactModeActivated()">
    <button mat-button (click)="onClickDropoff()">{{ value() || dropOffId() }}</button>
  </div>
}
